export default __webpack_public_path__ + "static/media/73569d1734bc8fd277aed086626410911598975720921.1fbefda2.webp";